import React from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  FolderRounded as FolderIcon,
  PictureAsPdfRounded as PdfIcon,
  DescriptionRounded as XlsxIcon,
} from '@material-ui/icons';

import { InvoiceFormat, InvoiceFormats } from '../../types/invoice-format.type';

const INVOICE_FORMAT_ICONS: Record<InvoiceFormat, React.ReactElement> = {
  [InvoiceFormats.PDF]: <PdfIcon />,
  [InvoiceFormats.XLSX]: <XlsxIcon />,
  [InvoiceFormats.ZIP]: <FolderIcon />,
};

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 4,
    textTransform: 'capitalize',
    backgroundColor: '#f0f0f0',
    color: '#000000',
    '&:hover, &:focus': {
      backgroundColor: '#f0f0f0',
    },
  },
}));

type Props = {
  format: InvoiceFormat;
  size?: 'small' | 'medium';
};

export function InvoiceFormatChip({ format, size = 'small' }: Props) {
  const classes = useStyles();
  return <Chip className={classes.root} icon={INVOICE_FORMAT_ICONS[format]} label={format} size={size} />;
}
